import { render, staticRenderFns } from "./InputTextAreaVariable.vue?vue&type=template&id=7bf6edd0&scoped=true"
import script from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
export * from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
import style0 from "./InputTextAreaVariable.vue?vue&type=style&index=0&id=7bf6edd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf6edd0",
  null
  
)

export default component.exports